var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPromoteAndGrowYourSiteBusiness = function SvgPromoteAndGrowYourSiteBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0v10.292l4.5-4.5 2 2.001 6.646-6.647a.5.5 0 0 1 .765.638l-.057.07L7.5 9.207l-2-2L1 11.706V13h14v1H0V0h1Z",
    fill: "#162D3D"
  })));
};
export default SvgPromoteAndGrowYourSiteBusiness;